/**
 * 全局异常处理
 * @param {
 * } error
 * @param {*} vm
 */

function isPromise(ret) {
  return (ret && typeof ret.then === 'function' && typeof ret.catch === 'function');
}
// eslint-disable-next-line complexity
const errorHandler = (error, vm) => {
  console.error('捕获错误', error);
  console.error('错误的组件', vm);
  const errorType = Object.prototype.toString.call(error);
  const ableParse = /String/.test(errorType) || (/Object/.test(errorType) && error.name && error.message) || /Error/.test(errorType);
  let raw;
  // 不符合标准的error单独打点
  if (!ableParse) {
    try {
      raw = JSON.stringify(error);
    } catch (e) {
      console.log(e);
    }
    error = 'invalid-error';
  }
  Owl.addError(error, {
    tags: {
      type: 'addError',
      currentPoiId: vm && vm.currentPoi && vm.currentPoi.poiId,
      raw,
      vnodeTag: vm && vm.$vnode && vm.$vnode.tag,
    },
  });
};

function registerActionHandle(actions) {
  Object.keys(actions).forEach((key) => {
    const fn = actions[key];
    actions[key] = function (...args) {
      const ret = fn.apply(this, args);
      if (isPromise(ret)) {
        return ret.catch(errorHandler);
      } else { // 默认错误处理
        return ret;
      }
    };
  });
}
const registerVuex = (instance) => {
  if (instance.$options.store) {
    const actions = instance.$options.store._actions || {};
    if (actions) {
      const tempActions = {};
      Object.keys(actions).forEach((key) => {
        tempActions[key] = actions[key][0];
      });
      registerActionHandle(tempActions);
    }
  }
};
const registerVue = (instance) => {
  if (instance.$options.methods) {
    const actions = instance.$options.methods || {};
    if (actions) {
      registerActionHandle(actions);
    }
  }
};

const GlobalError = {
  install: (Vue) => {
    /**
         * 全局异常处理
         * @param {
         * } error
         * @param {*} vm
         */
    Vue.config.errorHandler = errorHandler;
    Vue.mixin({
      beforeCreate() {
        registerVue(this);
        registerVuex(this);
      },
    });
    Vue.prototype.$throw = errorHandler;
  },
};

export default GlobalError;
